import { render, staticRenderFns } from "./FormCleave.vue?vue&type=template&id=e4c8c546&"
import script from "./FormCleave.vue?vue&type=script&lang=js&"
export * from "./FormCleave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports